import {ColumnsType} from "antd/lib/table";
import {Direction, ProductDto} from "../../api";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {CrudTable, nameof} from "digimuth-components/dist";
import {Button, Tag} from "antd";
import {ArrowDownOutlined, ArrowUpOutlined} from "@ant-design/icons";
import {generatePath, useNavigate, useParams} from "react-router-dom";
import {RoutingPaths} from "../routing/routingContainer";

export default function ProductsList(props: ProductListProps) {

    const navigate = useNavigate();
    const {categoryId} = useParams();

    const columns: ColumnsType<ProductDto> = [
        {
            title: "Pozycja",
            render: (_, record, position) => <>
                <Button
                    style={position === 0 ? {visibility: "hidden"} : {visibility: "visible"}}
                    icon={<ArrowUpOutlined/>}
                    onClick={() => props.onPositionChangeClicked!(record.id!, Direction.Up)}
                />
                <Button
                    style={position === props.data?.length! - 1 ? {visibility: "hidden"} : {visibility: "visible"}}
                    icon={<ArrowDownOutlined/>}
                    onClick={() => props.onPositionChangeClicked!(record.id!, Direction.Down)}
                />
            </>
        },
        {
            key: nameof<ProductDto>("name"),
            dataIndex: nameof<ProductDto>("name"),
            title: "Nazwa"
        },
        {
            key: nameof<ProductDto>("description"),
            dataIndex: nameof<ProductDto>("description"),
            title: "Opis",
            render: (description: string) => <span dangerouslySetInnerHTML={{__html: description.substring(0, 100) + (description.length > 100 ? "..." : "") }}/>
        },
        //old way of rendering tags, leaving it commented 
        // {
        //     key: nameof<ProductDto>("tags"),
        //     dataIndex: nameof<ProductDto>("tags"),
        //     title: "Tagi",
        //     render: tags => {
        //         return <div style={{display: "flex"}}>
        //             {tags && tags.map((tag: TagDto, index: number) => (
        //                 <Tag color="blue" key={index}>
        //                     {tag.value}
        //                 </Tag>
        //             ))}
        //         </div>
        //     }
        // }
        {
            key: nameof<ProductDto>("wineVariety"),
            dataIndex: nameof<ProductDto>("wineVariety"),
            title: "Szczep wina"
        }
    ];

    function onGoToPrices(id: number) {
        navigate(generatePath(RoutingPaths.productsPriceTable.route, {
            productId: id.toString(),
            categoryId: categoryId!.toString(),
        }));
    }

    function onGoToDetails(id: number) {
        navigate(generatePath(RoutingPaths.productsDetailsTable.route, {
            productId: id.toString(),
            categoryId: categoryId!.toString()
        }));
    }

    return <CrudTable
        data={props.data}
        onAddClicked={props.onAddClicked}
        onEditClicked={props.onEditClicked}
        onDeleteClicked={props.onDeleteClicked}
        isLoading={props.isLoading}
        columns={columns}
        cancelButtonTitle={"Anuluj"}
        deleteButtonTitle={"Usuń"}
        editButtonTitle={"Edytuj"}
        deleteConfirmMessage={"Czy na pewno chesz usunąć ten produkt?"}
        addButtonTitle={"+ Dodaj nowy produkt"}
        customRowActions={record => <>
            <Button onClick={() => onGoToPrices(record.id!)}>
                Ceny
            </Button>
            <Button onClick={() => onGoToDetails(record.id!)}>
                Szczegóły
            </Button>
        </>
        }
        customActions={() => <Button onClick={props.onAddExistingClicked}>
            Dodaj istniejący produkt
        </Button>}
    />;
}

interface ProductListProps extends CrudTableWrapperProps<ProductDto> {
    onPositionChangeClicked: (id: number, direction: Direction) => void,
    onAddExistingClicked: () => void,
}
